/* eslint-disable */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const LeadDisablePopup = ({
  selectedLeadIds = [],
  showDeleteOffcanvas = false,
  onPopupClose = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
  setShowAlert = () => {},
  reloadLeadList = () => {},
}) => {
  const { t } = useTranslation(); // for translations
  const token = localStorage.getItem("token");

  const [leadList, setLeadList] = useState([]); // New state for lead list data
  const [isLoading, setIsLoading] = useState(false);

  const [reason, setReason] = useState("");
  const [isDeleteing, setIsDeleteing] = useState(false);

  //fetch lead list from api and set to state
  const getLeadList = async () => {
    setIsLoading(true);
    try {
      const apiData = {
        leadids: selectedLeadIds,
      };

      const requestUrl =
        url.API_BASE_URL +
        url.API_GET_LEAD_DISABLE_ELIGIBILITY +
        `?token=${token}`;

      const response = await postData(requestUrl, apiData);

      console.log("Lead Disable Eligibility Response:", response);

      if (response.status) {
        setLeadList(response.data);
      }
    } catch (error) {
      console.error("Error fetching lead list:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //delete selected leads
  const deleteLeadHandler = async () => {
    setIsDeleteing(true);
    try {
      const leadListToBeDelete = leadList
        .filter((item) => item.disablestatus === "1")
        .map((item) => item.leadid); // map leadid from leadlist

      const formatedLeadIds = leadListToBeDelete.map((item) => ({
        _id: item,
      }));

      let apiData = {
        leadlist: formatedLeadIds,
        reason: reason,
      };

      const requestUrl =
        url.API_BASE_URL + url.API_DELETE_BULK_LEAD + `?token=${token}`;

      const response = await putData(requestUrl, apiData);

      console.log("Lead Disable Response:", response);

      if (response.status) {
        setMessageType("success");
        closeOffcanvas();
        setTimeout(() => {
          //disable offcanvas
          const offcanvasElement = document.getElementById("leadDisablePopup");
          const offcanvasInstance =
            window.bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (offcanvasInstance) {
            offcanvasInstance.hide();
          }

          reloadLeadList(leadListToBeDelete);
        }, 1000);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setIsDeleteing(false);
      setShowAlert(true);
    }
  };

  // Clear selected user IDs when closing the offcanvas
  const closeOffcanvas = () => {
    setReason("");
    onPopupClose();
  };

  useEffect(() => {
    if (selectedLeadIds.length > 0 && showDeleteOffcanvas) {
      getLeadList();
    }
  }, [selectedLeadIds, showDeleteOffcanvas]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="leadDisablePopup"
      aria-labelledby="leadDisablePopupLabel"
      style={{ display: "flex", flexDirection: "column", height: "100vh" }}
    >
      <div
        className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300"
        style={{ zIndex: 2 }}
      >
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              delete
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="leadDisablePopupLabel"
            >
              {t("Disable Lead")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Selected lead disable eligibility & status")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closeOffcanvas}
        ></button>
      </div>
      <div
        className="offcanvas-body p-4"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
      >
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {/* Table Header */}
            <div
              className="bg-primary text-white rounded-top overflow-hidden shadow-sm mb-0"
              style={{ position: "sticky", top: 0, zIndex: 1 }}
            >
              <div className="row g-0 fw-semibold py-3 px-2">
                {/* ...existing code for header columns... */}
                <div className="col-2 px-2">
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      person
                    </span>
                    <span className="d-none d-md-inline">
                      {t("Selected Leads")}
                    </span>
                    <span className="d-md-none">Leads</span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      task
                    </span>
                    <span className="d-none d-lg-inline">{t("Tasks")}</span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      monetization_on
                    </span>
                    <span className="d-none d-lg-inline">
                      {t("Opportunity")}
                    </span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      note_add
                    </span>
                    <span className="d-none d-lg-inline">{t("Notes")}</span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      person
                    </span>
                    <span className="d-none d-lg-inline">{t("Ecoleads")}</span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      event
                    </span>
                    <span className="d-none d-lg-inline">{t("Job Resp")}</span>
                  </div>
                </div>
                <div className="col-1 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      assignment
                    </span>
                    <span className="d-none d-lg-inline">{t("Survey")}</span>
                  </div>
                </div>
                <div className="col-3 px-2 text-center">
                  <div className="d-flex align-items-center justify-content-center gap-1">
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "18px" }}
                    >
                      toggle_off
                    </span>
                    <span>{t("Disable Status")}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Table Body - scrollable */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                minHeight: 0,
                maxHeight: "40vh",
                background: "white",
              }}
            >
              <ul className="list-unstyled mb-4 bg-white rounded-bottom shadow-sm overflow-hidden">
                {leadList.map((lead, index) => (
                  <li
                    key={index}
                    className={`border-bottom ${index === leadList.length - 1 ? "border-0" : ""}`}
                    style={{
                      transition: "background-color 0.2s ease",
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8f9fa")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "white")
                    }
                  >
                    <div className="row g-0 align-items-center py-3 px-2">
                      <div className="col-2 px-2">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={
                              lead.leadimage === ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + lead.leadimage
                            }
                            alt={lead.leadname}
                            className="rounded-circle border border-2 border-primary shadow-sm flex-shrink-0"
                            style={{
                              width: "40px",
                              height: "40px",
                              objectFit: "cover",
                            }}
                          />
                          <span className="fw-semibold text-truncate">
                            {lead.leadname}
                          </span>
                        </div>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.tasks > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.tasks}
                        </span>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.opportunities > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.opportunities}
                        </span>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.notes > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.notes}
                        </span>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.purchase > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.purchase}
                        </span>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.challengeresponses > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.challengeresponses}
                        </span>
                      </div>
                      <div className="col-1 px-2 text-center">
                        <span
                          className={`badge ${lead.survey > 0 ? "bg-primary" : "bg-primary bg-opacity-25 text-primary"} px-3 py-2 rounded-pill fw-semibold`}
                        >
                          {lead.survey}
                        </span>
                      </div>
                      <div className="col-3 px-2 text-center">
                        <span
                          className={`badge ${lead.disablestatus === "1" ? "bg-success" : "bg-danger"} px-3 py-2 fw-semibold d-inline-flex align-items-center gap-1`}
                        >
                          <span
                            className="material-symbols-outlined"
                            style={{ fontSize: "16px" }}
                          >
                            {lead.disablestatus === "1"
                              ? "check_circle"
                              : "block"}
                          </span>
                          {lead.disablestatuscode}
                        </span>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
      <div
        className="offcanvas-footer p-4 bg-white border-top border-gray-300 rounded-bottom shadow-sm"
        style={{ position: "sticky", bottom: 0, zIndex: 10 }}
      >
        {" "}
        <div className="mb-3">
          <label
            htmlFor="reason"
            className="form-label fw-bold d-flex align-items-center gap-2"
          >
            <span className="material-symbols-outlined text-primary">
              edit_note
            </span>
            {t("Reason (optional)")}
          </label>
          <textarea
            className="form-control shadow-sm"
            id="reason"
            rows={3}
            placeholder={t("Enter reason for disabling lead")}
            style={{ border: "2px solid #dee2e6", borderRadius: "8px" }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          ></textarea>
        </div>
        <div className="d-flex justify-content-end gap-2 pt-3 mt-auto">
          <button
            type="button"
            className="btn btn-primary px-4 d-flex align-items-center gap-2 shadow"
            onClick={deleteLeadHandler}
            disabled={isDeleteing}
            style={{
              cursor: isDeleteing ? "not-allowed" : "pointer",
            }}
          >
            {isDeleteing ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              <span
                className="material-symbols-outlined"
                style={{ fontSize: "18px" }}
              >
                check
              </span>
            )}
            {t("Confirm")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadDisablePopup;
